import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { wrap } from 'popmotion';
import { GAtrack } from '../../Utils/tracking';

import style from './image-with-dropdown.module.scss';
import { Button } from '../ButtonBar/button';

const tagChange = (athlete, direction, title) => {
  const dataLayerArgs = {
    // dataLayer: {
    event: 'rbVideoTracking',
    event_name: 'video_sidebar',
    video_sidebar: {
      value: `Slider – ${direction}`,
      widget_type: `ImageWithDropDown - ${title}`,
      widget_type_profile: `${athlete.label}`
    }
    // eventCategory: 'video',
    // eventAction: 'sidebar'
    // }
  };

  GAtrack(dataLayerArgs);
};

const Image = ({ setAutopoll, alt, options, selected, setSelected, config }) => {
  const [[page, direction], setPage] = useState([0, 0]);

  const variants = {
    enter: (direction) => {
      return {
        x: direction > 0 ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction) => {
      return {
        zIndex: 0,
        x: direction < 0 ? 1000 : -1000,
        opacity: 0
      };
    }
  };

  useEffect(() => {
    const currentIndex = options.findIndex((option) => option.value === selected.value);
    let newDirection = -1;

    if (
      (currentIndex > page && currentIndex !== options.length - 1) ||
      (currentIndex === options.length - 1 && page === options.length - 2) ||
      (page === options.length - 1 && currentIndex === 0)
    ) {
      newDirection = 1;
    }

    setPage([currentIndex, newDirection]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <div style={{ minHeight: config.height, position: 'relative', marginTop: -16 }}>
      <AnimatePresence initial={false} custom={direction}>
        <motion.img
          style={{ position: 'absolute', left: 0, width: '100%' }}
          key={options[page].label}
          alt={alt}
          src={options[page].image}
          custom={direction}
          variants={variants}
          transition={{
            x: { type: 'spring', stiffness: 300, damping: 30 },
            opacity: { duration: 0.2 }
          }}
          exit="exit"
          className="image"
          initial="enter"
          animate="center"
        />
        {options[page].buttons &&
          Array.isArray(options[page].buttons) &&
          options[page].buttons.length &&
          options[page].buttons.map((button, index) => {
            const buttonVariants = {
              ...variants,
              center: {
                ...variants.center,
                x:
                  button.position.left === '50%'
                    ? '-50%'
                    : button.position.right === '50%'
                    ? '50%'
                    : 0
              }
            };

            return (
              <motion.div
                key={`${index}-${button.text}-${page}`}
                style={{ ...button.position, position: 'absolute', zIndex: 1000 }}
                custom={direction}
                variants={buttonVariants}
                transition={{
                  x: { type: 'spring', stiffness: 300, damping: 30 },
                  opacity: { duration: 0.2 }
                }}
                exit="exit"
                className="image"
                initial="enter"
                animate="center"
              >
                <Button
                  key={button.text}
                  {...button}
                  onClick={() => {
                    const dataLayerArgs = {
                      // dataLayer: {
                      event: 'rbVideoTracking',
                      event_name: 'video_sidebar',
                      video_sidebar: {
                        value: `Button - ${button.text}`,
                        widget_type: `ImageWithDropDown - ${
                          config.trackingTitle || config.navigationTitle
                        }`,
                        widget_type_profile: `${options[page].label}`
                      }
                      // eventCategory: 'video',
                      // eventAction: 'sidebar'
                      // }
                    };

                    GAtrack(dataLayerArgs);
                  }}
                >
                  {button.text}
                </Button>
              </motion.div>
            );
          })}
      </AnimatePresence>
      <div
        className={`${style.controlls}`}
        style={{ top: config.arrowPostionFromTop }}
        onClick={() => {
          setAutopoll(false);
          const nextIndex = wrap(0, options.length, page - 1);
          tagChange(
            options[nextIndex],
            'Previous',
            config.trackingTitle || config.navigationTitle
          );
          setSelected(options[nextIndex]);
        }}
      ></div>
      <div
        className={`${style.controlls} ${style.right}`}
        style={{ top: config.arrowPostionFromTop }}
        onClick={() => {
          setAutopoll(false);
          const nextIndex = wrap(0, options.length, page + 1);
          tagChange(
            options[nextIndex],
            'Next',
            config.trackingTitle || config.navigationTitle
          );
          setSelected(options[nextIndex]);
        }}
      ></div>
    </div>
  );
};

export { Image };
